export default {
    namespaced: true,
    state: {
        body: '',
        body_beefree: '',
        is_loading: false
    },
    mutations: {
        // 本文をセット
        setBody(state, body) {
            state.body = body;
        },
        // 本文Beefreeをセット
        setBodyBeefree(state, body_beefree) {
            state.body_beefree = body_beefree;
        },
        // loadingフラグをセット
        setIsLoading(state, is_loading) {
            state.is_loading = is_loading;
        }
    },
    actions: {},
    getters: {
        // 本文を取得
        getBody(state) {
            return state.body;
        },
        // 本文Beefreeを取得
        getBodyBeefree(state) {
            return state.body_beefree;
        },
        // loadingフラグを取得
        getIsLoading(state) {
            return state.is_loading;
        }
    }
};
